var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination"},[_c('mds-pagination',{class:{ disabledNext: _vm.dataLength < 100},attrs:{"total-items":_vm.totalElements,"page":_vm.paginationOptions.page},on:{"mds-pagination-page-changed":_vm.handlePageChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }